import * as React from 'react';
import classnames from 'classnames';
import { Label, Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const PrescriptionAvailabilityIndicator = ({ className  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Label, {
        type: "neutral",
        className: classnames('prescription-availability-indicator', className)
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "store-eye-test",
        className: "prescription-availability-indicator__icon"
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, getLabel('products.prescriptionAvailable')));
};

export { PrescriptionAvailabilityIndicator };
//# sourceMappingURL=PrescriptionAvailabilityIndicator.js.map
